import View from './View';

class SearchView extends View {
  _parentElement = document.querySelector('.search');

  getQuery() {
    const input = this._parentElement.querySelector('.search__field').value;
    this._clearInput();
    return input;
  }

  _clearInput() {
    this._parentElement.querySelector('.search__field').value = '';
  }

  addSearchHandler(handler) {
    // Will work whether user clicks on the button or "enter" key
    this._parentElement.addEventListener('submit', function (e) {
      e.preventDefault();
      handler();
    });
  }
}

export default new SearchView();
